import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import { forwardRef, useEffect } from "react";
// @mui
import { Box } from "@mui/material";
import { useAppContext } from "src/hooks";

// ----------------------------------------------------------------------

const Page = forwardRef(
  ({ children, title = "", height = null, meta, ...other }, ref) => {
    const { badge } = useAppContext();
    const unreadChatPrefix = badge?.chat > 0 ? `(${badge.chat}) ` : "";

    useEffect(() => {
      document.title = `${unreadChatPrefix}${title} | DONE`;
    }, [title, unreadChatPrefix]);


    return (
      <>
        <Helmet>
          <title>{`${unreadChatPrefix}${title} | DONE`}</title>
          {meta}
        </Helmet>

        <Box
          className="pb-3"
          id="page-box"
          minHeight={height || "89vh"}
          position="relative"
          ref={ref}
          {...other}
        >
          {children}
        </Box>
      </>
    );
  }
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
};

export default Page;
